import { render, staticRenderFns } from "./NewMenuManagementV2.vue?vue&type=template&id=1c136ee5"
import script from "./NewMenuManagementV2.vue?vue&type=script&lang=js"
export * from "./NewMenuManagementV2.vue?vue&type=script&lang=js"
import style0 from "./NewMenuManagementV2.vue?vue&type=style&index=0&id=1c136ee5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports